import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.js';
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import { withRouter } from 'react-router-dom';

import DrawerHeader from './components/Header';
import SideItems from './components/SideItems';
import Footer from './components/Footer';


class DrawerMenu extends Component {
  render(){
    const { classes, theme } = this.props;
    return(
      <div>
        <div className={classes.sideItems}>
          <DrawerHeader />
          <SideItems />
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(DrawerMenu));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/index.js